import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const Dashboard = () => {
  const [freePaidData, setFreePaidData] = useState([]);
  const [userPlanData, setUserPlanData] = useState([]);
  const [startDate1, setStartDate1] = useState(moment().format("YYYY-MM-DD"));
  const [endDate1, setEndDate1] = useState(moment().format("YYYY-MM-DD"));
  const [startDate2, setStartDate2] = useState(moment().format("YYYY-MM-DD"));
  const [endDate2, setEndDate2] = useState(moment().format("YYYY-MM-DD"));

  useEffect(() => {
    document.title = "Dashboard - Calendar Services";
  }, []);

  
  useEffect(() => {
    const initializeDateRangePickers = () => {
      $("#kt_daterangepicker_1").daterangepicker(
        {
          startDate: moment(),
          endDate: moment(),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
          },
        },
        (start, end) => {
          setStartDate1(start.format("YYYY-MM-DD"));
          setEndDate1(end.format("YYYY-MM-DD"));
        }
      );


      $("#kt_daterangepicker_2").daterangepicker(
        {
          startDate: moment(),
          endDate: moment(),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
          },
        },
        (start, end) => {
          setStartDate2(start.format("YYYY-MM-DD"));
          setEndDate2(end.format("YYYY-MM-DD"));
        }
      );
    };

    initializeDateRangePickers();
  }, []);


  // Function to send expiry messages
  const handleSendExpiryMessage = (expiryType) => {
    axios
      .post(`${API_BASE_URL}/api/send-expiry-message`, { expiryType })
      .then((response) => {
        alert(`Expiry message sent successfully: ${response.data.message}`);
      })
      .catch((error) => {
        console.error(error);
        alert("Error sending expiry message");
      });
  };

  
  // Function to clear view count
  const handleClearViewCount = () => {
    axios
      .post(`${API_BASE_URL}/api/clear-view-count`)
      .then((response) => {
        alert("View count cleared successfully");
      })
      .catch((error) => {
        console.error(error);
        alert("Error clearing view count");
      });
  };



  const fetchFreePaidData = useCallback(() => {
    axios
      // .post("http://localhost:3036/api/datewise-free-paid", { startDate: startDate1, endDate: endDate1 })
      .post(`${API_BASE_URL}/api/datewise-free-paid`, { startDate: startDate1, endDate: endDate1 })
      // .post("https://calendarservicesapi.nithra.mobi/api/datewise-free-paid", { startDate: startDate1, endDate: endDate1 })
      .then((response) => setFreePaidData(response.data))
      .catch((error) => console.error(error));
  }, [startDate1, endDate1]);



  const fetchUserPlanData = useCallback(() => {
    axios
      // .post("http://localhost:3036/api/datewise-user-plans", { startDate: startDate2, endDate: endDate2 })
      .post(`${API_BASE_URL}/api/datewise-user-plans`, { startDate: startDate2, endDate: endDate2 })
      // .post("https://calendarservicesapi.nithra.mobi/api/datewise-user-plans", { startDate: startDate2, endDate: endDate2 })
      .then((response) => setUserPlanData(response.data))
      .catch((error) => console.error(error));
  }, [startDate2, endDate2]);

  useEffect(() => {
    if (startDate1 && endDate1) {
      fetchFreePaidData();
    }
  }, [startDate1, endDate1, fetchFreePaidData]);

  useEffect(() => {
    if (startDate2 && endDate2) {
      fetchUserPlanData();
    }
  }, [startDate2, endDate2, fetchUserPlanData]);


  const calculateTotals = () => {
    if (userPlanData.length === 0) return {};

    const totals = {
      user: "Total",
      free: 0,
      basic_plan: 0,
      one_month: 0,
      three_month: 0,
      six_month: 0,
      one_year: 0,
      two_year: 0,
      new_year: 0,
      total_amount: 0,
    };

    userPlanData.forEach((row) => {
      totals.free += row.free || 0;
      totals.basic_plan += row.basic_plan || 0;
      totals.one_month += row.one_month || 0;
      totals.three_month += row.three_month || 0;
      totals.six_month += row.six_month || 0;
      totals.one_year += row.one_year || 0;
      totals.two_year += row.two_year || 0;
      totals.new_year += row.new_year || 0;
      totals.total_amount += row.total_amount || 0;
    });

    return totals;
  };

  const totalRow = calculateTotals();
  const tableData = [...userPlanData, totalRow]; // Append totals row to data

  return (
    <div className="bg-gray-100 py-9 px-4">
      <header className="mb-9">
        <h1 className="text-2xl font-bold text-center text-black-900 mb-4">
          Welcome to Admin Dashboard
        </h1>
          <p className="text-center py-3">(ஜோதிடர், புரோகிதர், வாஸ்து நிபுணர் Modules)</p>
        <div className="flex justify-center gap-6">
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded shadow"
            onClick={() => handleSendExpiryMessage("three_days")}
          >
            Expiry 3 Days Message
          </button>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded shadow"
            onClick={() => handleSendExpiryMessage("today")}
          >
            Today Expiry Message
          </button>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded shadow"
            onClick={() => handleSendExpiryMessage("expiry")}
          >
            Expired 3 Days Message
          </button>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded shadow"
            onClick={handleClearViewCount}
          >
            Clear View Count
          </button>
        </div>
      </header>

      <div className="max-w-2xl mx-auto mt-3 bg-white shadow rounded">
        <div className="bg-white shadow rounded p-8 mb-2">
          <h2 className="text-lg font-medium text-gray-700 mb-1">
            Datewise Free & Paid Plan Counts
          </h2>
          <div className="mb-3">
            <div className="text-center mb-6 flex items-center space-x-2 justify-center">
            <div id="kt_daterangepicker_1" className="bg-white border px-4 py-2 inline-block rounded cursor-pointer">
        {`${moment(startDate1).format("MMMM D, YYYY")} - ${moment(endDate1).format("MMMM D, YYYY")}`}
      </div>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
                />
              </svg>
            </div>
          </div>
          <div className="flex justify-around text-sm font-medium text-gray-700">
            <div className="bg-green-500 text-white px-4 py-2 rounded mt-3">
              Free Count: {freePaidData.reduce((sum, item) => sum + item.free_count, 0)}
            </div>
            <div className="bg-red-500 text-white px-4 py-2 rounded mt-3">
              Paid Count: {freePaidData.reduce((sum, item) => sum + item.paid_count, 0)}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto mt-8 bg-white shadow-md rounded">
        <div className="bg-white shadow rounded-lg p-4">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Datewise User's & App Plan Counts
          </h2>
          <div className="mb-3">
            <div className="text-center mb-6 flex items-center space-x-2 justify-center">
            <div id="kt_daterangepicker_2" className="bg-white border px-4 py-2 inline-block rounded cursor-pointer">
        {`${moment(startDate1).format("MMMM D, YYYY")} - ${moment(endDate1).format("MMMM D, YYYY")}`}
      </div>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
                />
              </svg>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto">
              <thead>
                <tr className="bg-gray-200">
                  <th className="px-4 py-2 text-left">Name</th>
                  <th className="px-4 py-2 text-left">Free Plan</th>
                  <th className="px-4 py-2 text-left">Basic plan</th>
                  <th className="px-4 py-2 text-left">One Month Plan</th>
                  <th className="px-4 py-2 text-left">Three Month Plan</th>
                  <th className="px-4 py-2 text-left">Six Month Plan</th>
                  <th className="px-4 py-2 text-left">One Year Plan</th>
                  <th className="px-4 py-2 text-left">Two YearPlan</th>
                  <th className="px-4 py-2 text-left">New Year Plan</th>
                  <th className="px-4 py-2 text-left">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index} className="border-t">
                    <td className="px-4 py-2">{row.user}</td>
                    <td className="px-4 py-2">{row.free}</td>
                    <td className="px-4 py-2">{row.basic_plan}</td>
                    <td className="px-4 py-2">{row.one_month}</td>
                    <td className="px-4 py-2">{row.three_month}</td>
                    <td className="px-4 py-2">{row.six_month}</td>
                    <td className="px-4 py-2">{row.one_year}</td>
                    <td className="px-4 py-2">{row.two_year}</td>
                    <td className="px-4 py-2">{row.new_year}</td>
                    <td className="px-4 py-2">{row.total_amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
